module.exports = __webpack_public_path__ + "static/almir-c5062ea4dc710e8662864e929d4cc13b.png";